/* eslint-disable react/jsx-props-no-spreading */

import clsx from 'clsx';
import { ClapperboardIcon, LucideIcon, LucideProps, PlayIcon } from 'lucide-preact';
import { ComponentProps } from 'preact/compat';

export const SwitchCameraIcon: LucideIcon = ({ className, ...props }) => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={clsx('preflight preflight-svg', className)}
    {...(props as ComponentProps<'svg'>)}
  >
    <path
      fill="currentColor"
      d="M5.53579 9.76857H14.6181C15.5466 9.76857 16.4548 9.00162 16.4548 8.0732V2.9669C16.4548 2.03848 15.5466 1.13025 14.6181 1.13025H12.7613C12.7613 0.383477 11.9944 0 11.0659 0H9.06782C8.1394 0 7.37244 0.383477 7.37244 1.13025H5.51561C4.58719 1.13025 3.67896 2.0183 3.67896 2.9669V8.0732C3.67896 9.00162 4.58719 9.76857 5.53579 9.76857ZM10.077 2.68434C11.6512 2.68434 12.9228 3.95587 12.9228 5.53014C12.9228 7.10442 11.6512 8.37595 10.077 8.37595C8.50269 8.37595 7.23116 7.10442 7.23116 5.53014C7.23116 3.95587 8.50269 2.68434 10.077 2.68434Z"
    />
    <path
      fill="currentColor"
      d="M19.3813 8.74344C18.9373 8.40033 18.5134 8.23886 18.2309 8.11776C17.9483 7.99666 17.7868 7.9563 17.7868 7.9563C17.7868 7.9563 17.9281 8.03703 18.1905 8.1985C18.4327 8.35996 18.796 8.62234 19.1391 9.00582C19.3006 9.18746 19.4418 9.42966 19.5226 9.67185C19.5831 9.91405 19.5629 10.1764 19.4216 10.3984C19.1593 10.8627 18.5336 11.2058 17.8676 11.4681C16.5153 11.9727 14.9007 12.1745 13.508 12.2553C12.9631 12.2956 12.4383 12.2956 11.9741 12.2956V14.4552C12.5191 14.3947 13.1246 14.2938 13.7704 14.1727C15.264 13.8497 16.9391 13.3653 18.3923 12.4975C18.7556 12.2755 19.0987 12.0333 19.4015 11.7507C19.7042 11.4681 19.9666 11.125 20.1079 10.7012C20.2492 10.2975 20.2088 9.83332 20.0271 9.51039C19.8455 9.12691 19.6033 8.9049 19.3813 8.74344Z"
    />
    <path
      fill="currentColor"
      d="M1.80193 12.4774C3.25511 13.3452 4.9303 13.8296 6.42384 14.1526C6.90823 14.2535 7.39262 14.3342 7.83665 14.3948V15.6865L10.4604 13.426L7.83665 11.1655V12.2755C7.47335 12.2755 7.08988 12.2554 6.68622 12.2352C5.29359 12.1544 3.67895 11.9728 2.32669 11.4682C1.66065 11.226 1.03498 10.8627 0.752413 10.4187C0.611132 10.1967 0.570766 9.9545 0.651498 9.69212C0.712047 9.44992 0.853328 9.20773 1.01479 9.02608C1.33772 8.6426 1.70101 8.40041 1.96339 8.21876C2.20559 8.05729 2.36705 7.97656 2.36705 7.97656C2.36705 7.97656 2.20559 8.01693 1.92303 8.13803C1.64047 8.25913 1.23681 8.42059 0.772596 8.7637C0.550583 8.94535 0.308387 9.16736 0.146923 9.49029C-0.0145407 9.81322 -0.0549067 10.2774 0.0863743 10.6811C0.227655 11.0847 0.510217 11.4279 0.812962 11.7306C1.09552 12.0132 1.43864 12.2554 1.80193 12.4774Z"
    />
  </svg>
);

export const SpeakerIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={clsx('preflight preflight-svg', className)}
    {...props}
  >
    <path
      d="M2 7.33333L14 4V12L2 9.33333V7.33333Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7338 11.2C7.66377 11.4539 7.54441 11.6915 7.38254 11.8993C7.22067 12.107 7.01947 12.2809 6.79042 12.4109C6.56137 12.5409 6.30895 12.6245 6.04759 12.6569C5.78622 12.6894 5.52103 12.67 5.26714 12.6C5.01325 12.53 4.77564 12.4106 4.56788 12.2487C4.36012 12.0869 4.18628 11.8857 4.05627 11.6566C3.92627 11.4276 3.84266 11.1751 3.8102 10.9138C3.77775 10.6524 3.7971 10.3872 3.86714 10.1333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AppleIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 640 640"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={clsx('preflight preflight-svg', className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M494.782 340.02c-.803-81.025 66.084-119.907 69.072-121.832-37.595-54.993-96.167-62.552-117.037-63.402-49.843-5.032-97.242 29.362-122.565 29.362-25.253 0-64.277-28.607-105.604-27.85-54.32.803-104.4 31.594-132.403 80.245C29.81 334.457 71.81 479.58 126.816 558.976c26.87 38.882 58.914 82.56 100.997 81 40.512-1.594 55.843-26.244 104.848-26.244 48.993 0 62.753 26.245 105.64 25.406 43.606-.803 71.232-39.638 97.925-78.65 30.887-45.12 43.548-88.75 44.316-90.994-.969-.437-85.029-32.634-85.879-129.439l.118-.035zM414.23 102.178C436.553 75.095 451.636 37.5 447.514-.024c-32.162 1.311-71.163 21.437-94.253 48.485-20.729 24.012-38.836 62.28-33.993 99.036 35.918 2.8 72.591-18.248 94.926-45.272l.036-.047z"
    />
  </svg>
);

export const FacebookIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 509 509"
    fillRule="evenodd"
    clipRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={clsx('preflight preflight-svg', className)}
    {...props}
  >
    <g fillRule="nonzero">
      <path
        fill="currentColor"
        d="M509 254.5C509 113.94 395.06 0 254.5 0S0 113.94 0 254.5C0 373.86 82.17 474 193.02 501.51V332.27h-52.48V254.5h52.48v-33.51c0-86.63 39.2-126.78 124.24-126.78 16.13 0 43.95 3.17 55.33 6.33v70.5c-6.01-.63-16.44-.95-29.4-.95-41.73 0-57.86 15.81-57.86 56.91v27.5h83.13l-14.28 77.77h-68.85v174.87C411.35 491.92 509 384.62 509 254.5z"
      />
      <path
        fill="#fff"
        d="M354.18 332.27l14.28-77.77h-83.13V227c0-41.1 16.13-56.91 57.86-56.91 12.96 0 23.39.32 29.4.95v-70.5c-11.38-3.16-39.2-6.33-55.33-6.33-85.04 0-124.24 40.16-124.24 126.78v33.51h-52.48v77.77h52.48v169.24c19.69 4.88 40.28 7.49 61.48 7.49 10.44 0 20.72-.64 30.83-1.86V332.27h68.85z"
      />
    </g>
  </svg>
);

export const HighlightIcon = ({ className, ...props }: Omit<LucideProps, 'children'>) => (
  <ClapperboardIcon {...props} className={clsx('preflight preflight-svg', className)}>
    <PlayIcon size={8} y={12} x={8} absoluteStrokeWidth />
  </ClapperboardIcon>
);
